<template lang="pug">
  #Home
    Header(style='position: relative;z-index: 10000;')

    //- ── CAROUSEL ──────────────────────────────────────────────────────────────
    section.section-carousel
      v-skeleton-loader.mx-auto#ld(v-if='policeCarousel' max-height='520' style='width:100%;' type='image')
      div(v-if='carousel && carousel.length > 0')
        v-carousel(height='auto' hide-delimiters='' cycle interval='5000')
          v-carousel-item(v-for='(item, i) in carousel' :key='i')
            img(:src='ruta + item.imagen' style='height:auto;width:100%;object-fit:cover;display:block;')

    //- ── FEATURES ──────────────────────────────────────────────────────────────
    section.section-features
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='10' md='10')
            v-row
              v-col(cols='12' sm='6' md='3')
                div.feature-card
                  div.feature-icon-wrap
                    img(src='@/assets/imgFerco/papel.png' class='feature-icon')
                  div.feature-text
                    span.feature-title Mayor ferretero
                    span.feature-sub Gran variedad de stock
              v-col(cols='12' sm='6' md='3')
                div.feature-card
                  div.feature-icon-wrap
                    img(src='@/assets/imgFerco/people.png' class='feature-icon')
                  div.feature-text
                    span.feature-title Equipo comprometido
                    span.feature-sub Con nuestros clientes
              v-col(cols='12' sm='6' md='3')
                div.feature-card
                  div.feature-icon-wrap
                    img(src='@/assets/imgFerco/camion.png' class='feature-icon')
                  div.feature-text
                    span.feature-title Entregas rápidas
                    span.feature-sub Inmediatas y seguras
              v-col(cols='12' sm='6' md='3')
                div.feature-card.no-border
                  div.feature-icon-wrap
                    img(src='@/assets/imgFerco/tienda.png' class='feature-icon')
                  div.feature-text
                    span.feature-title Llegamos hasta
                    span.feature-sub Cada establecimiento

    //- ── BANNERS ───────────────────────────────────────────────────────────────
    section.section-banners(v-if='policeBanners || (bannersI && bannersD)')
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='10' md='10')
            v-row
              v-col(cols='12' sm='12' md='6')
                v-skeleton-loader.mx-auto#ld2(v-if='policeBanners' style='width:100%;' type='image')
                div.banner-wrap(v-if='bannersI')
                  img(:src='ruta + bannersI.imagen' class='banner-img')
              v-col(cols='12' sm='12' md='6')
                v-skeleton-loader.mx-auto#ld2(v-if='policeBanners' style='width:100%;' type='image')
                div.banner-wrap(v-if='bannersD')
                  img(:src='ruta + bannersD.imagen' class='banner-img')

    //- ── MARCAS DESTACADAS ─────────────────────────────────────────────────────
    section.section-marcas(v-if='policeMarcas || (marcasWeb && marcasWeb.length > 0)')
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='10' md='10')
            div.section-header(v-if='policeMarcas')
              v-skeleton-loader.mx-auto#ld2(max-height='30' max-width='200' type='image')
            div.section-header(v-else)
              h2.section-title Marcas destacadas
            div(v-if='policeMarcas')
              carousel(:perPageCustom="[[320, 1],[480, 2], [768, 4], [1160, 6]]")
                slide(v-for='(item,i) in arraySke' :key='i' style='padding: 0 8px;')
                  div.carouselMarkSke
                    v-skeleton-loader.mx-auto#ld3(style='width:100%;' type='image')
            div(v-if='marcasWeb && marcasWeb.length > 0')
              carousel(:perPageCustom="[[320, 1],[480, 2], [768, 4], [1160, 6]]")
                slide(v-for='(item,i) in marcasWeb' :key='i' style='padding: 0 8px;')
                  div.marca-card(@click='irProdMarca(item)')
                    div.marca-img-wrap
                      img(:src='ruta + item.imagen' class='marca-img')
                    span.marca-name {{item.cat_des}}

    //- ── CATEGORÍAS ────────────────────────────────────────────────────────────
    section.section-categorias(v-if='policeCategorias || (categoriasWeb && categoriasWeb.length > 0)')
      v-container(fluid)

        //- Skeleton categorias
        div(v-if='policeCategorias')
          v-row(justify='center' style='padding: 40px 0;')
            v-col(cols='12' sm='10' md='10')
              v-skeleton-loader.mx-auto#ld2(max-height='30' max-width='200' style='margin-bottom:24px;' type='image')
              v-row
                v-col(cols='12' sm='12' md='6')
                  v-skeleton-loader.mx-auto#ld4(style='width:100%;' type='image')
                v-col(cols='6' sm='6' md='3' v-for='(x,i) in arraySkeP' :key='i')
                  v-skeleton-loader.mx-auto#ld3(style='width:100%;' type='image')

        //- Categorias reales
        div(v-if='categoriasWeb && categoriasWeb.length > 0')
          div.categoria-block(v-for='(item,i) in categoriasWeb' :key='i')
            v-row(justify='center')
              v-col(cols='12' sm='10' md='10')
                div.categoria-header
                  h2.section-title {{item.subl_des}}
                  span.ver-todos(@click='irProductos(item)') Ver todos →
                v-card.categoria-card(elevation='0')
                  v-row(no-gutters)
                    v-col(cols='12' sm='12' md='5')
                      div.categoria-main-img(@click='irProductos(item)')
                        img(:src='ruta + item.imagen' class='cat-main-img')
                    v-col(cols='12' sm='12' md='7')
                      v-row.fill-height
                        v-col(
                          cols='6' sm='6' md='4'
                          v-for='(prod,j) in item.productos'
                          :key='j'
                        )
                          div.prod-card(@click='ir(prod._id)')
                            div.prod-img-wrap
                              img(:src='ruta + prod.imagen[0].url' class='prod-img')
                            div.prod-info
                              span.prod-name {{prod.art_des}}
                              span.prod-marca {{prod.marcaN}}
                              span.prod-stock(v-if='mostrarS') Existencia: {{prod.stock}}
                              span.prod-precio(v-if='mostrarP') ${{prod.precio}}

    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import { serverImg } from '@/services/environment'
export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      arraySke: ['1', '2', '3', '4', '5', '6', '7', '8'],
      arraySkeP: ['1', '2', '3', '4', '5', '6'],
      policeCarousel: true,
      policeCategorias: true,
      policeBanners: true,
      policeMarcas: true,
      categoriasWeb: [],
      marcasWeb: [],
      carousel: [],
      bannersD: null,
      bannersI: null,
      mostrarP: false,
      mostrarS: false,
      tamanno: window.screen.width,
      ruta: serverImg
    }
  },
  created () {
    this.initialize()
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.stock) {
      this.mostrarS = this.$store.state.fercoWeb.stock
    }
  },
  methods: {
    ir (item) {
      this.$router.push('/detalle/' + item)
    },
    irProdMarca (item) {
      this.$router.push({ name: 'Productos', params: { marca: item } })
    },
    irProductos (item) {
      this.$router.push({ name: 'Productos', params: { categoria: item } })
    },
    async initialize () {
      const cli = (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_precio) ? this.$store.state.fercoWeb.co_precio.trim() : null
      await Api.get('categoriaWeb/withProduct?codigo=' + cli).then(res => {
        this.categoriasWeb = res.data
        this.policeCategorias = false
      })
      await Api.get('marcas/withImg').then(res => {
        this.marcasWeb = res.data
        this.policeMarcas = false
      })
      await Api.get('carousel').then(res => {
        this.carousel = res.data
        this.policeCarousel = false
      })
      await Api.get('banners').then(res => {
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i]
          if (el.posicion == 'Izquierda') this.bannersI = el
          if (el.posicion == 'Derecha') this.bannersD = el
        }
        this.policeBanners = false
      })
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/home.scss";
</style>
